import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WdxButtonModule } from '@wdx/shared/components/wdx-button';
import { WdxIconButtonModule } from '@wdx/shared/components/wdx-icon-button';
import { WdxIconModule } from '@wdx/shared/components/wdx-icon';
import { TranslateTokenisedStringPipe } from '@wdx/shared/utils';
import { PushPipe } from '@ngrx/component';
import { WdxIconContainerModule } from '@wdx/shared/components/wdx-icon-container';
import { WdxInfoCardModule } from '@wdx/shared/components/wdx-info-card';
import { WdxListGroupModule } from '@wdx/shared/components/wdx-list-group';
import {
    WorkflowDesignerComponent,
    WorkflowDesignerParameterGroupComponent,
    WorkflowDesignerParameterInputComponent,
    WorkflowDesignerParameterQueryComponent,
    WorkflowDesignerParametersComponent,
    WorkflowDesignerStepsComponent,
    WorkflowDesignerVisualComponent,
} from './components';
import { ReactiveFormsModule } from '@angular/forms';
import { WdxInputTextModule } from '@wdx/shared/components/wdx-input-text';
import { WdxFormFieldModule } from '@wdx/shared/components/wdx-form-field';
import { NgSelectModule } from '@ng-select/ng-select';
import { WdxIsLoadingModule } from '@wdx/shared/components/wdx-is-loading';
import { WdxCheckboxModule } from '@wdx/shared/components/wdx-checkbox';
import { WdxInputDateModule } from '@wdx/shared/components/wdx-input-date';
import { WdxInputTimeModule } from '@wdx/shared/components/wdx-input-time';
import { NgxCurrencyDirective } from 'ngx-currency';
import { WdxDropdownModule } from '@wdx/shared/components/wdx-dropdown';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { WdxBadgeModule } from '@wdx/shared/components/wdx-badge';
import { WdxStopPropagationDirective } from '@wdx/shared/components/wdx-stop-propagation';
import { WdxJsonViewerComponent } from '@wdx/shared/components/wdx-json-editor';
import { KeyValueOrderPipe, SortByFieldPipe } from './pipes';
import { WorkflowFormWrappedControlComponent } from './components/workflow-wrapped-form-control/workflow-wrapped-form-control.component';
import { WorkflowWrappedControlDirective } from './components/workflow-wrapped-form-control/workflow-wrapped-form-control-host.directive';
import { WorkflowDesignerParameterSegmentedComponent } from './components/workflow-designer-parameters/parameter-segmented';
import { WorkflowDesignerCurrencyControlComponent } from './components/workflow-designer-parameters/currency-control/workflow-designer-currency-control.component';

export const IMPORTS = [
    CommonModule,
    WdxButtonModule,
    WdxIconButtonModule,
    WdxIconContainerModule,
    WdxIconModule,
    WdxInfoCardModule,
    WdxListGroupModule,
    TranslateTokenisedStringPipe,
    PushPipe,
    ReactiveFormsModule,
    WdxFormFieldModule,
    WdxInputTextModule,
    WdxInputTimeModule,
    WdxInputDateModule,
    WdxCheckboxModule,
    NgxCurrencyDirective,
    NgSelectModule,
    WdxIsLoadingModule,
    WdxDropdownModule,
    NgbDropdownModule,
    WdxBadgeModule,
    WdxStopPropagationDirective,
    WdxJsonViewerComponent,
    KeyValueOrderPipe,
    SortByFieldPipe,
];

@NgModule({
    imports: IMPORTS,
    declarations: [
        WorkflowDesignerComponent,
        WorkflowDesignerStepsComponent,
        WorkflowDesignerParametersComponent,
        WorkflowDesignerParameterGroupComponent,
        WorkflowDesignerParameterInputComponent,
        WorkflowDesignerParameterQueryComponent,
        WorkflowDesignerParameterSegmentedComponent,
        WorkflowDesignerCurrencyControlComponent,
        WorkflowDesignerVisualComponent,
        WorkflowFormWrappedControlComponent,
        WorkflowWrappedControlDirective,
    ],
    exports: [WorkflowDesignerComponent],
})
export class WorkflowDesignerModule {}
